import { axiosCompanyPortalInstance } from "./";

const EVENT_REQUESTS_PATH = "/event_requests";
const BULK_STATUS_VALIDATE = (status) =>
  (status >= 200 && status < 300) || status === 207;

const getCompanyPortalEventRequests = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get(EVENT_REQUESTS_PATH, { ...config, params });

const getCompanyPortalCountries = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get("/countries", { ...config, params });

const getCompanyPortalCities = (params = {}, config = {}) =>
  axiosCompanyPortalInstance.get("/cities", { ...config, params });

const bulkApproveCompanyPortalEventRequests = (data) =>
  axiosCompanyPortalInstance.post(
    `${EVENT_REQUESTS_PATH}/bulk_approve`,
    data,
    { validateStatus: BULK_STATUS_VALIDATE },
  );

const bulkRejectCompanyPortalEventRequests = (data) =>
  axiosCompanyPortalInstance.post(
    `${EVENT_REQUESTS_PATH}/bulk_reject`,
    data,
    { validateStatus: BULK_STATUS_VALIDATE },
  );

const bulkAllocateCompanyPortalEventRequests = (data) =>
  axiosCompanyPortalInstance.post(
    `${EVENT_REQUESTS_PATH}/bulk_allocate`,
    data,
    { validateStatus: BULK_STATUS_VALIDATE },
  );

const bulkUnassignCompanyPortalEventRequests = (data) =>
  axiosCompanyPortalInstance.post(
    `${EVENT_REQUESTS_PATH}/bulk_unassign`,
    data,
    { validateStatus: BULK_STATUS_VALIDATE },
  );

const bulkRemoveCompanyPortalEventRequests = (data) =>
  axiosCompanyPortalInstance.post(
    `${EVENT_REQUESTS_PATH}/bulk_remove`,
    data,
    { validateStatus: BULK_STATUS_VALIDATE },
  );

const bulkChangeRoleCompanyPortalEventRequests = (data) =>
  axiosCompanyPortalInstance.post(
    `${EVENT_REQUESTS_PATH}/bulk_change_role`,
    data,
    { validateStatus: BULK_STATUS_VALIDATE },
  );

const exportCompanyPortalEventRequests = (data = {}, config = {}) =>
  axiosCompanyPortalInstance.post(`${EVENT_REQUESTS_PATH}/export_xls`, data, config);

export {
  getCompanyPortalEventRequests,
  getCompanyPortalCountries,
  getCompanyPortalCities,
  bulkApproveCompanyPortalEventRequests,
  bulkRejectCompanyPortalEventRequests,
  bulkAllocateCompanyPortalEventRequests,
  bulkUnassignCompanyPortalEventRequests,
  bulkRemoveCompanyPortalEventRequests,
  bulkChangeRoleCompanyPortalEventRequests,
  exportCompanyPortalEventRequests,
};
